const contactInfos = [
  {
    icon: "/assets/img/icon/08.svg",
    title: "Gọi Hỗ Trợ:",
    content: <a href="tel:0704888009">0704.888.009</a>,
    delay: ".3s",
  },
  {
    icon: "/assets/img/icon/09.svg",
    title: "Email Liên Hệ:",
    content: <a href="mailto:design24.vn@gmail.com">Design24.vn@gmail.com</a>,
    delay: ".5s",
  },
  {
    icon: "/assets/img/icon/10.svg",
    title: "Địa Chỉ Văn Phòng",
    content: <>166 đường Nguyễn Văn Cừ Nối Dài, An Bình, Ninh Kiều, Cần Thơ</>,
    delay: ".7s",
  },
];

const ContactInfoSection = () => {
  return (
    <section className="contact-info-section fix section-padding">
      <div className="container">
        <div className="row g-4">
          {contactInfos.map((info, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={info.delay}
            >
              <div className="contact-box-items">
                <div className="icon">
                  <img
                    src={info.icon}
                    alt="icon liên hệ"
                  />
                </div>
                <div className="content">
                  <h3>{info.title}</h3>
                  <p>{info.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
